import React from "react";

interface Props {}

const GoogleSvg = (props: Props) => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.366667"
        y="0.366667"
        width="54.2667"
        height="54.2667"
        rx="10.6333"
        stroke="#E2E8F0"
        stroke-width="0.733333"
      />
      <path
        d="M34.9648 26.3133L34.8871 25.9836H27.722V29.0162H32.0031C31.5586 31.1268 29.4961 32.2378 27.8114 32.2378C26.5856 32.2378 25.2934 31.7222 24.4382 30.8934C23.9869 30.4492 23.6278 29.9203 23.3812 29.337C23.1346 28.7538 23.0055 28.1276 23.0013 27.4944C23.0013 26.217 23.5754 24.9393 24.4107 24.0989C25.246 23.2584 26.5075 22.7881 27.7619 22.7881C29.1984 22.7881 30.2279 23.5509 30.6129 23.8988L32.7679 21.7552C32.1358 21.1997 30.3991 19.7999 27.6924 19.7999C25.6042 19.7999 23.6018 20.5998 22.1381 22.0587C20.6937 23.4952 19.946 25.5725 19.946 27.4999C19.946 29.4273 20.6535 31.4008 22.0532 32.8487C23.5489 34.3928 25.6671 35.1999 27.8482 35.1999C29.8326 35.1999 31.7136 34.4224 33.0543 33.0116C34.3722 31.6229 35.0539 29.7013 35.0539 27.6869C35.0539 26.8389 34.9686 26.3353 34.9648 26.3133Z"
        fill="#2D3748"
      />
    </svg>
  );
};

export default GoogleSvg;
